export default __webpack_public_path__ + "68b218a478acf4fd9e6247f27d5d485a.webp";